// extracted by mini-css-extract-plugin
module.exports = {"emailSuggestion":"KDHgRb","button":"_377ZfL"};